import React from 'react';
import { Search } from 'lucide-react';
import { FilterChips } from './Tabs';
import type { TabItem } from './Tabs';

export const SearchField: React.FC<{
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
}> = ({ value, onChange, placeholder }) => (
  <div className="flex h-9 w-full items-center gap-2 rounded-act border border-line bg-white px-3 transition-colors focus-within:border-ink sm:w-[260px]">
    <Search className="h-4 w-4 shrink-0 text-ink-soft" />
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={placeholder}
      className="w-full border-0 bg-transparent text-[13px] text-ink outline-none placeholder:text-ink-soft"
    />
  </div>
);

export const ListToolbar: React.FC<{
  chips: TabItem[];
  active: string;
  onChipChange: (id: string) => void;
  chipsLabel: string;
  query: string;
  onQueryChange: (v: string) => void;
  placeholder: string;
  note?: React.ReactNode;
  children?: React.ReactNode;
}> = ({ chips, active, onChipChange, chipsLabel, query, onQueryChange, placeholder, note, children }) => (
  <div className="border-b border-line-soft px-5 py-4 md:px-6">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <FilterChips tabs={chips} active={active} onChange={onChipChange} label={chipsLabel} />
      <SearchField value={query} onChange={onQueryChange} placeholder={placeholder} />
    </div>
    {note && <p className="m-0 mt-3 text-[12px] leading-[18px] text-ink-soft">{note}</p>}
    {children}
  </div>
);
